import React from "react";
import { Typography, AccordionSummary } from "@material-ui/core";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import cn from "classnames";
import { useBulkExportContext } from "../../../../providers";
import { useStyles } from "./Summary.styles";
import { getDisplayOutput } from "./Summary.utils";
import type { FC } from "react";
import type { ISummaryProps } from "./Summary.types";
import { IDimension } from "../../../../types";

export const Summary: FC<ISummaryProps> = (props) => {
  const { type, name, open, hierarchyIdentifier, items, item, favoriteBulkItemByQuery } = props;
  const context = useBulkExportContext();
  const classes = useStyles();
  const id = `${hierarchyIdentifier}bh-header`;
  const ariaControls = `${hierarchyIdentifier}bh-content`;

  let dimension;

  if (favoriteBulkItemByQuery) {
    dimension = context?.state.currentFavouriteSettings?.mark.parameters.dimensions.find((d) => d.id === hierarchyIdentifier);
  } else if (item && "mark" in item) {
    dimension =
      context?.state.currentFavouriteSettings?.mark.parameters.dimensions.find((d) => d.id === hierarchyIdentifier) ||
      (item?.mark?.parameters?.dimensions as IDimension[]).find((d) => (d as IDimension).id === hierarchyIdentifier);
  } else {
    dimension = context?.state.dimensions.find((d) => d.id === hierarchyIdentifier);
  }
  const selection = dimension?.selection ?? [];
  const displayOutput = getDisplayOutput(type, selection, items ?? []);

  return (
    <AccordionSummary
      classes={{
        root: classes.summary,
        content: classes.summaryContent,
        expanded: classes.summaryExpanded,
        expandIcon: classes.expandIcon,
      }}
      expandIcon={<ArrowRightIcon />}
      aria-controls={ariaControls}
      id={id}
    >
      <Typography className={cn(classes.heading, { opened: open })}>{name}</Typography>
      <Typography className={cn(classes.secondaryHeading, { opened: open })}>{displayOutput}</Typography>
    </AccordionSummary>
  );
};
